import {
  NAME_REG_EXP,
  DateFormat,
  EMAIL_REG_EXP,
  PASSWORD_REG_EXP,
  GST_REG_EXP,
  PAN_REG_EXP,
  TAN_REG_EXP,
  companyName_Exp,
  NAME_HYPHEN_REG_EXP,
  NUMBERS_ONLY_REG_EXP,
} from "../common/const";

export function isValidName(val) {
  return NAME_REG_EXP.test(val);
}

export function isValidMobile(val) {
  return NUMBERS_ONLY_REG_EXP.test(val);
}

export function isValidEmail(val) {
  return EMAIL_REG_EXP.test(val);
}

export function isValidPasswordFormat(val) {
  return PASSWORD_REG_EXP.test(val);
}

export function isNullUndefinedEmpty(val) {
  if (
    val === "undefined" ||
    val === undefined ||
    val === null ||
    val === "" ||
    val.trim() === ""
  ) {
    return true;
  }
  return false;
}

export function isValidDateFormat(val) {
  return DateFormat.test(val);
}
export function isValidDate(val) {
  return;
}
export function isValidcompanyName(val) {
  return companyName_Exp.test(val);
}
export function isValidGST(val) {
  return GST_REG_EXP.test(val);
}
export function isValidKeyPressDate(keyCode) {
  if (
    !(keyCode >= 48 && keyCode <= 57) &&      // NOT a number key (0-9) from main keyboard
    !(keyCode >= 96 && keyCode <= 105) &&     // NOT a number key (0-9) from numeric keypad
    keyCode !== 8 &&                          // NOT Backspace
    keyCode !== 109 &&                        // NOT Numpad minus (-)
    keyCode !== 189                           // NOT minus (-) on main keyboard
  ) {
    return true;
  } else {
    return false;
  }
}
export function isValidKeyPressNumber(keyCode) {
  if (
    keyCode === 32 ||
    (keyCode !== 8 && isNaN(String.fromCharCode(keyCode)))
  ) {
    return true;
  } else {
    return false;
  }
}
export function isDecimalKey(txt, keyCode) {
  const decimalObj = txt.split(".");
  if ((keyCode >= 48 && keyCode <= 57) || keyCode == 46) {
    if (decimalObj.length > 1) {
      if (keyCode == 46) return true;
    } else if (keyCode == 46) {
      //keyCode == 46; //Check if the text already contains the . character
      if (txt.indexOf(".") === -1) {
        return false;
      } else {
        return true;
      }
    } else if (keyCode !== 8 && isNaN(String.fromCharCode(keyCode))) {
      return true;
    }
  } else return true;
}

export function isPercentage(value) {
  var ex = /^[0-9]+\.?[0-9]*$/;
  if (ex.test(value) == true || value == "") {
    if (value <= 100) {
      const decimalObj = value.split(".");
      if (decimalObj.length > 1) {
        if (decimalObj[1].length > 2) {
          return false;
        }
      }
      return true;
    }
  }
}
export function isValidPAN(val) {
  return PAN_REG_EXP.test(val);
}

export function isValidTAN(val) {
  return TAN_REG_EXP.test(val);
}

export function isValidMobileNo(val) {
  if (val.length === 10) {
    return true;
  }
  return false;
}
export function isValidNameHyphen(val) {
  return NAME_HYPHEN_REG_EXP.test(val);
}
export function errorRequired(value, label) {
  if (isNullUndefinedEmpty(value)) {
    if (
      label === "Address Type" ||
      label === "State" ||
      label === "GSTIN Status" ||
      label === "Tax Payer Type"
    ) {
      return "Please select a valid " + label;
    } else {
      return "Please enter a valid " + label;
    }
  }
  return "";
}
